import instance from '../Config/axios'
import { AUTHORIZATION } from '../constants/requestsUrl';

export const getValidateAuthorization = async (hash) => {
    const url = `${AUTHORIZATION.GET}/${hash}`;
  
    return instance.get(url);
};